export default "__VITE_ASSET__CBMKzWGA__"